export const AFFILIATE_QUERY_KEY = 'affiliate';
export const AFFILIATE_STORAGE_KEY = 'invertAffiliateCode';

export function normalizeAffiliateCode(code) {
    if (code === undefined || code === null) {
        return null;
    }
    const trimmed = String(code).trim();
    if (!trimmed || trimmed.length > 64) {
        return null;
    }
    if (!/^[a-zA-Z0-9_-]+$/.test(trimmed)) {
        return null;
    }
    return trimmed;
}

export function persistAffiliateCode(code) {
    const normalized = normalizeAffiliateCode(code);
    if (!normalized) {
        return null;
    }
    try {
        sessionStorage.setItem(AFFILIATE_STORAGE_KEY, normalized);
    } catch (_) {
        // Ignore storage failures (private mode, quota, etc.)
    }
    return normalized;
}

export function getStoredAffiliateCode() {
    try {
        return normalizeAffiliateCode(sessionStorage.getItem(AFFILIATE_STORAGE_KEY));
    } catch (_) {
        return null;
    }
}

export function getAffiliateCodeFromSearch(search) {
    const params = new URLSearchParams(search || '');
    return normalizeAffiliateCode(params.get(AFFILIATE_QUERY_KEY));
}

export function resolveAffiliateCode(search) {
    const fromUrl = getAffiliateCodeFromSearch(search);
    if (fromUrl) {
        persistAffiliateCode(fromUrl);
        return fromUrl;
    }
    return getStoredAffiliateCode();
}

export function buildAffiliateRedirectUrl(basePath, affiliateCode, extraParams = {}) {
    const normalized = normalizeAffiliateCode(affiliateCode);
    if (!normalized) {
        return basePath;
    }
    const params = new URLSearchParams(extraParams);
    params.set(AFFILIATE_QUERY_KEY, normalized);
    const qs = params.toString();
    return qs ? `${basePath}?${qs}` : basePath;
}

export function appendAffiliateToUrl(url, affiliateCode) {
    const normalized = normalizeAffiliateCode(affiliateCode);
    if (!normalized) {
        return url;
    }
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}${AFFILIATE_QUERY_KEY}=${encodeURIComponent(normalized)}`;
}
